import {Option, option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import {BillOfMaterialsPreviewDetails} from "../../model/job/BillOfMaterialsPreviewDetails";
import {Bom} from "../../model/job/Bom";

/**
 * Gets Bill of Materials details basing on job id.
 * @param jobId
 * @param {RootState} state State of the redux.
 * @returns {Option<Bom>} BillOfMaterialsPreviewDetails.
 */
export function getBillOfMaterialsByJobId(jobId: string, state: RootState): Option<Bom> {
	const bom = state.billOfMaterials.bomMap[jobId];
	return option(bom);
}